import { memo } from 'react';
import { useSelector } from 'react-redux';
import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import { selectSeo } from '@containers/Home/selectors';

function PageSeo() {
  const seo = useSelector(selectSeo);
  const router = useRouter();
  const canonical =
    (typeof window !== 'undefined'
      ? window.location.origin
      : process.env.NEXT_PUBLIC_SITE_URL || '') + router.asPath;

  return (
    <NextSeo
      title={seo?.title || ''}
      description={seo?.description || ''}
      canonical={canonical}
      openGraph={{
        type: 'website',
        title: seo?.title || '',
        description: seo?.description || '',
        images: seo?.image
          ? [
              {
                url: seo?.image,
                width: 800,
                height: 600,
                alt: '',
              },
            ]
          : [],
      }}
    />
  );
}

export default memo(PageSeo);
